import { getWithdrawalHistories } from "@endpoints/payment.service";
import dayjs from "@lib/dayjs";
import { useEffect, useState } from "react";
import PaymentReceived from "./PaymentReceived";
import LoaderPaymentReceived from "../components/LoaderPaymentReceived";

const WithdrawalHistory = () => {
  const [withdrawalHistories, setWithdrawalHistories] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  async function fetchWithdrawalHistories() {
    try {
      setIsLoading(true);
      const { success, data } = await getWithdrawalHistories();
      if (success) {
        setWithdrawalHistories(data?.payouts);
      }
    } catch (error) {
      console.error("Error: fetching withdrawal histories", error);
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    fetchWithdrawalHistories();
  }, []);

  return (
    <div className="flex flex-col pt-5 px-3 gap-2 min-h-0">
      <span className="font-bold text-sm">Withdrawal History</span>
      <div className="grid grid-cols-[1.5fr_1.5fr_1fr_1fr_1fr] bg-[#FAFAFA] rounded-md py-2.5 px-8">
        <span className="text-xs font-semibold text-light-black">
          Transaction ID
        </span>
        <span className="text-xs font-semibold text-light-black">Amount</span>
        <span className="text-xs font-semibold text-light-black">Method</span>
        <span className="text-xs font-semibold text-light-black">Status</span>
        <span className="text-xs font-semibold text-light-black">Date</span>
      </div>
      {/* List */}
      <div className="flex flex-col min-h-0 overflow-y-scroll no-scrollbar flex-1">
        {isLoading ? (
          <LoaderPaymentReceived />
        ) : (
          withdrawalHistories?.map((item) => {
            return (
              <div
                key={item?._id}
                className="grid grid-cols-[1.5fr_1.5fr_1fr_1fr_1fr] rounded-md px-8 py-2.5"
              >
                <span className="text-xs font-medium text-charcoal line-clamp-1 w-20">
                  {item?.balance_transaction?.toUpperCase()}
                </span>
                <span className="text-xs font-medium text-charcoal">
                  £{item?.amount / 100}
                </span>
                <span className="text-xs font-medium text-charcoal">
                  Bank Name 1
                </span>
                <span className="text-xs font-medium text-charcoal capitalize">
                  {item?.status}
                </span>
                <span className="text-xs font-medium text-charcoal">
                  {dayjs.unix(item?.created)?.format("DD MMM YYYY, hh:mm a")}
                </span>
              </div>
            );
          })
        )}
        {/* {Array.from({ length: 2 })?.map(() => {
          return (
            <div className="grid grid-cols-[1.5fr_1.5fr_1fr_1fr_1fr] rounded-md px-8 py-2.5">
              <span className="text-xs font-medium text-charcoal">TXN14356</span>
              <span className="text-xs font-medium text-charcoal">£1500</span>
              <span className="text-xs font-medium text-charcoal">
                Bank Name 1
              </span>
              <span className="text-xs font-medium text-charcoal">Pending</span>
              <span className="text-xs font-medium text-charcoal">
                09 Nov 2025
              </span>
            </div>
          );
        })} */}
      </div>
    </div>
  );
};

export default WithdrawalHistory;
